import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { PoAutoApprovalPage } from './po-auto-approval.page';

const routes: Routes = [
  {
    path: '',
    component: PoAutoApprovalPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PoAutoApprovalPageRoutingModule {}
